const configGeneralOptions = [
  {
    code: 'config_advance_algorithm',
    name: 'Algoritmo de avance',
    description: "El avance del sistema se determina mediante un modelo de consolidación proporcional. Cada Tracker se desglosa en sus elementos constituyentes (obra civil, estructura y montaje fotovoltaico), donde el progreso global del activo es la suma ponderada del avance individual de cada componente según su incidencia técnica en la unidad total.",
    icon: 'calculator',
    order: 1,
    type: 'item',
  },
  {
    code: 'config_visibility_statuses',
    name: 'Visibilidad de los estados',
    description: "Establece qué perfiles tienen autorización para interactuar con los estados operativos y reportar el progreso físico de los componentes.",
    icon: 'eye',
    order: 2,
    type: 'item',
  },
  {
    code: 'config_simultaneous_statuses',
    name: 'Registro Simultáneo de Estados',
    description: "Habilita la capacidad de reportar múltiples estados de forma simultánea, agilizando el registro.",
    icon: 'sync',
    order: 3,
    type: 'item',
  },
  {
    code: 'config_actions_permitted',
    name: 'Acciones permitidas',
    description: "Establece si se permiten acciones adicionales y permite configurar cuales son las acciones permitidas.",
    icon: 'check-circle',
    order: 4,
    type: 'item',
  },
  {
    code: 'config_statuses',
    name: 'Configuración de estados',
    description: "Crear, editar, eliminar estados.",
    icon: 'cog',
    order: 5,
    type: 'item',
  },
  {
    code: 'config_bulk_actions',
    name: 'Replicar a otras capas',
    description: 'Replicar configuración o estados de esta capa al resto del pictograma.',
    icon: 'copy',
    order: 6,
    type: 'item',
  }
]

// Opciones específicas por tipo de estado
// Formato: config{statusCode}Options (ejemplo: configProgressOptions, configIncidentsOptions)
// const configProgressOptions = [...]
// const configIncidentsOptions = [...]

// Registro de opciones específicas por código de estado
const statusSpecificOptionsRegistry = {
  // progress: configPilingsOptions,
  // pillars: configStructuresOptions,
  // Agregar aquí nuevas opciones específicas cuando se creen
}

/**
 * Obtiene todas las opciones de configuración disponibles para un estado
 * Busca dinámicamente si existe opciones específicas en el registro
 * @param {string} layerCode - Código del estado (ejemplo: 'progress', 'incidents')
 * @returns {Array} Lista de opciones de configuración ordenadas (generales primero, luego específicas)
 */
const getConfigStatusOptions = function (layerCode) {
  if (!layerCode) {
    return configGeneralOptions.sort((a, b) => a.order - b.order);
  }

  // Buscar opciones específicas del estado en el registro
  const specificOptions = statusSpecificOptionsRegistry[layerCode] || [];

  // Combinar opciones generales primero, luego las específicas
  const allOptions = [
    ...configGeneralOptions,
    ...specificOptions
  ];

  // Ordenar por el campo 'order'
  return allOptions.sort((a, b) => a.order - b.order);
}

export { getConfigStatusOptions }
